var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.986,
    height: 12.986,
    viewBox: "0 0 12.986 12.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2230",
    "data-name": "Rectangle 2230",
    width: 12.986,
    height: 12.986,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10202",
    "data-name": "Group 10202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10201",
    "data-name": "Group 10201",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27567",
    "data-name": "Path 27567",
    d: "M12.508,0H7.168A1.432,1.432,0,0,0,6.155.421L.42,6.156a1.432,1.432,0,0,0,0,2.026L4.8,12.566a1.432,1.432,0,0,0,2.026,0l5.735-5.735a1.432,1.432,0,0,0,.421-1.013V.478A.478.478,0,0,0,12.508,0M12.03,5.818a.477.477,0,0,1-.14.338L6.155,11.891a.477.477,0,0,1-.679,0L1.095,7.51a.477.477,0,0,1,0-.679L6.83,1.1a.477.477,0,0,1,.338-.14H12.03Z",
    transform: "translate(0 0)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27568",
    "data-name": "Path 27568",
    d: "M14.933,5.247A1.434,1.434,0,1,0,13.5,3.813a1.434,1.434,0,0,0,1.434,1.434m0-1.912a.478.478,0,1,1-.478.478.478.478,0,0,1,.478-.478",
    transform: "translate(-4.897 -0.863)",
    fill: "#152c40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon7);
export default __webpack_public_path__ + "static/media/social-icon7.b8ad54e0e587590369a111c0c8eb563a.svg";
export { ForwardRef as ReactComponent };